import { FontAwesome, Ionicons, MaterialIcons } from "@expo/vector-icons";
import {
	Box,
	Button,
	Card,
	Center,
	FlatList,
	FormControl,
	Heading,
	HStack,
	Icon,
	IconButton,
	Input,
	Modal,
	Select,
	Spacer,
	Stack,
	Text,
	TextField,
	Tooltip,
	VStack,
} from "native-base";
import React, { useState } from "react";
import { Dimensions, Platform, TouchableOpacity, View } from "react-native";
import DatePicker from "react-native-datepicker";
import { useSelector } from "react-redux";
import AppPagination from "../../utils/AppPagination";
import { isWeb } from "../../utils/utils";

const Picker = isWeb() ? require("react-rainbow-components").DatePicker : null;
const Pagination = isWeb()
	? require("react-rainbow-components").Pagination
	: null;
//require('../../utils/global.css');
//console.log(WebCss);
export const ComponentForm = (props) => {
	const { hooks, sitepagecomponent_meta, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		setFilter,
		filter,
		params,
	} = hooks;
	if (history !== "") {
		return (
			<Box {...sitepagecomponent_meta}>
				{/* <Button
					onPress={() => setFilter(!filter)}
					width={desktop ? "25%" : "50%"}
					style={{ alignSelf: "flex-end" }}
					key="filterBtn"
				>
					Filter
				</Button> */}
				<Tooltip label="Filter the results" openDelay={500}>
					<Button
						variant="ghost"
						key="filterBtn"
						onPress={() => setFilter(!filter)}
						style={{ alignSelf: "flex-end" }}
						startIcon={
							<Icon
								color="primary.500"
								size="sm"
								as={<FontAwesome name="filter" />}
							/>
						}
					>
						Filter
					</Button>
				</Tooltip>
				{filter ? (
					<>
						<Heading>{props.sitepagecomponent_meta.name}</Heading>
						<FormControl>{props.children}</FormControl>
					</>
				) : null}
			</Box>
		);
	}
	return (
		<View
			style={{
				marginTop: 120,
				alignItems: "center",
				justifyContent: "center",
				padding: 10,
				flex: 1,
			}}
		>
			<Tooltip
				label="Choose the history type by clicking on the buttons"
				openDelay={500}
			>
				<Box style={{ marginTop: -100 }}>
					<Icon
						color="primary.300"
						size="4xl"
						as={<Ionicons name="receipt-outline" />}
					/>
					<Text>Select history</Text>
				</Box>
			</Tooltip>
		</View>
	);
};
export const ComponentView = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	let mobile = props.sitepagecomponent_meta.mobile;
	var mobileProps = props.sitepagecomponent_meta;
	if (!desktop && props.mobile !== undefined) {
		mobileProps = { ...props.sitepagecomponent_meta, ...mobile };
	}
	return <Box {...mobileProps}>{props.children}</Box>;
};
export const ComponentButton = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	let BtnMapping = {
		submit: () => onSubmit(),
		cancel: () => onCancel(),
	};
	let mobile = props?.sitepagecomponent_meta?.mobile;
	var mobileProps = props.sitepagecomponent_meta;
	if (!desktop && props?.sitepagecomponent_meta.mobile !== undefined) {
		mobileProps = { ...props.sitepagecomponent_meta, ...mobile };
	}
	return (
		<Button
			style={{ marginBottom: 10, marginTop: 10 }}
			{...mobileProps}
			onPress={BtnMapping[props.sitepagecomponent_meta.type]}
		>
			{props.sitepagecomponent_meta.name}
		</Button>
	);
};
export const ComponentButtonGroup = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	let mobile = props?.sitepagecomponent_meta.mobile;
	var mobileProps = props.sitepagecomponent_meta;
	if (!desktop && props.sitepagecomponent_meta?.mobile !== undefined) {
		mobileProps = { ...props, ...mobile };
	}
	return <Button.Group {...mobileProps}>{props.children}</Button.Group>;
};
export const ComponentInput = (props) => {
	const [show, setShow] = useState(false);
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
		getData,
	} = hooks;
	const onChangeDate = (selectedDate, datatype_name) => {
		// console.log('selectedDate', selectedDate.toLocaleDateString('fr-CA'));
		// setShow(Platform.OS === 'ios');
		// selectedDate = selectedDate.toLocaleDateString('fr-CA');
		onChange(datatype_name, selectedDate);
	};
	let inputProps = props.sitepagecomponent_meta;
	delete inputProps.children;
	return (
		<>
			{inputProps.type === "text" &&
				inputProps[history] !== undefined &&
				inputProps[history] === true && (
					<>
						<FormControl.Label>{inputProps.label}</FormControl.Label>
						<Input
							onFocus={() => {
								// setCurrentInput(inputProps.name);
							}}
							size="md"
							{...inputProps}
							type="text"
							value={params[props.datatype_name]}
							onChangeText={(value) => onChange(props.datatype_name, value)}
						/>
					</>
				)}
			{inputProps.type === "select" &&
				inputProps[history] !== undefined &&
				inputProps[history] === true && (
					<>
						<FormControl.Label>{inputProps.label}</FormControl.Label>
						<Select
							{...inputProps}
							onValueChange={(value) => onChange(props.datatype_name, value)}
							selectedValue={params[props.datatype_name]}
						>
							{inputProps.options?.map((option) => (
								<Select.Item
									label={option.value}
									key={option.key}
									value={option.key}
								/>
							))}
						</Select>
					</>
				)}
			{inputProps.type === "date" && isWeb() && (
				<>
					<FormControl.Label>{inputProps.label}</FormControl.Label>
					<div
						className="rainbow-m-around_small datepicker"
						style={{ border: "#dedede", borderRadius: "5px" }}
					>
						<Picker
							style={{ border: "#dedede", borderRadius: "5px" }}
							containerStyle={{ border: "#dedede", borderRadius: "5px" }}
							formatStyle="medium"
							value={params[props.datatype_name]}
							onChange={(value) => onChangeDate(value, props.datatype_name)}
						/>
					</div>
				</>
			)}
			{inputProps.type === "date" && Platform.OS !== "web" && (
				<>
					<FormControl.Label>{inputProps.label}</FormControl.Label>
					<DatePicker
						style={{ width: "100%" }}
						date={
							params[props.datatype_name] === "" ||
							params[props.datatype_name] === undefined
								? ""
								: params[props.datatype_name]
						}
						mode="date"
						placeholder={inputProps.label}
						format="YYYY-MM-DD"
						minDate="2020-01-01"
						maxDate={new Date()}
						confirmBtnText="Confirm"
						cancelBtnText="Cancel"
						customStyles={{
							dateInput: {
								marginLeft: 0,
								borderWidth: 1,
								borderRadius: 18,
								borderColor: "rgb(213, 213, 213)",
								width: "100%",
							},
						}}
						onDateChange={(date) => onChange(props.datatype_name, date)}
					/>
				</>
			)}
		</>
	);
};
export const ComponentFlatList = (props) => {
	const { width, height } = Dimensions.get("window");
	const [modalVisible, setModalVisible] = useState(false);
	const [claim, setClaim] = useState([]);
	const [transaction, setTransaction] = useState([]);
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
		navigation,
		setAttachment,
		setOpenImage,
		setViewAttachment,
		loading,
		getData,
		offset,
		setOffset,
		tablePager,
	} = hooks;
	const { data, headings, title } = tableData;
	let keyField = "";
	if (history === "Claims") {
		keyField = "productclaim_guid";
	} else if (history === "Transactions") {
		keyField = "financialtransaction_guid";
	}
	const disputeClaim = (claim) => {
		navigation.navigate("Dispute Claim", claim);
	};
	const renderFooter = () => {
		return (
			//Footer View with Load More button
			<View
				style={
					desktop
						? {
								flexDirection: "row",
								justifyContent: "space-between",
								alignItems: "center",
								marginTop: 10,
								marginBottom: 10,
						  }
						: {
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								marginTop: 10,
								marginBottom: 10,
						  }
				}
			>
				<Button
					marginY={desktop ? 0 : 2}
					borderRadius={4}
					size={desktop ? "lg" : "sm"}
					key={"pageNumber"}
					isDisabled
				>{`Number of Records: ${tablePager.records}`}</Button>
				<AppPagination
					className="pagination-bar"
					currentPage={offset}
					totalCount={tablePager.records}
					pageSize={10}
					onPageChange={(page) => getData(page, history)}
				/>
			</View>
		);
	};
	const renderItem = ({ item }) => {
		return (
			<Box
				// bg="#fff"
				key={item[keyField]}
				borderBottomWidth="1"
				_dark={{
					borderColor: "gray.600",
				}}
				borderColor="coolGray.200"
				paddingY="2"
			>
				{history === "Claims" && (
					<TouchableOpacity
						onPress={() => {
							setClaim(item);
							setModalVisible(true);
						}}
					>
						{desktop ? (
							<HStack alignItems="flex-start" key={item.productclaim_guid}>
								<VStack
									style={{
										flex: 2.6,
									}}
								>
									{item?.product.length > 0 ? (
										item?.product.map((product) => {
											return (
												<Text alignSelf="flex-start" key={product.guid}>
													{product.data_text}
												</Text>
											);
										})
									) : (
										<Text alignSelf="center" key={item.productclaim_guid}>
											No Product
										</Text>
									)}
								</VStack>
								<Spacer />
								<VStack
									style={{
										flex: 1.8,
									}}
								>
									<Text
										// alignSelf="center"
										fontSize="xs"
										_dark={{
											color: "warmGray.50",
										}}
										color="coolGray.800"
									>
										{item.submission_date}
									</Text>
								</VStack>
								<Spacer />
								<VStack
									style={{
										flex: 1.2,
									}}
								>
									<Text
										alignSelf="flex-end"
										fontSize="xs"
										_dark={{
											color: "warmGray.50",
										}}
										color="coolGray.800"
									>
										{item.system_status?.type_description}
									</Text>
								</VStack>
							</HStack>
						) : (
							<HStack alignItems="flex-start" key={item.productclaim_guid}>
								<VStack style={{ flex: 2 }}>
									{item?.product.length > 0 ? (
										item?.product.map((product) => {
											return (
												<Text
													fontSize="xs"
													alignSelf="flex-start"
													key={product.guid}
												>
													{product.data_text}
												</Text>
											);
										})
									) : (
										<Text
											fontSize="xs"
											alignSelf="flex-start"
											key={item.productclaim_guid}
										>
											No Product
										</Text>
									)}
									<Text
										alignSelf="flex-start"
										fontSize="xs"
										style={{ fontSize: 8 }}
									>
										{item.system_status?.type_description}
									</Text>
								</VStack>
								<Spacer />
								<VStack style={{ flex: 1 }}>
									<Text
										alignSelf="flex-end"
										fontSize="xs"
										_dark={{
											color: "warmGray.50",
										}}
										color="coolGray.800"
										style={{ fontSize: 11 }}
									>
										{item.submission_date
											? item.submission_date.substring(0, 10)
											: item.submission_date}
									</Text>
								</VStack>
								<Spacer />
							</HStack>
						)}
					</TouchableOpacity>
				)}
				{history === "Transactions" && (
					<TouchableOpacity
						onPress={() => {
							setTransaction(item);
							setModalVisible(true);
						}}
					>
						{desktop ? (
							<HStack alignItems="flex-start" key={item[keyField]}>
								<VStack style={{ flex: 2 }}>
									<Text alignSelf="flex-start" key={item[keyField]}>
										{item.dbdate}
									</Text>
								</VStack>
								<Spacer />
								<VStack style={{ flex: 1 }}>
									<Text
										alignSelf="flex-start"
										fontSize="xs"
										_dark={{
											color: "warmGray.50",
										}}
										color="coolGray.800"
									>
										{item?.product_identifier}
									</Text>
								</VStack>
								<Spacer />
								<VStack style={{ flex: 1 }}>
									<Text
										alignSelf="flex-start"
										fontSize="xs"
										_dark={{
											color: "warmGray.50",
										}}
										color="coolGray.800"
									>
										{`R ${item.transaction_amount / 100}`}
									</Text>
								</VStack>
								<Spacer />
								<VStack style={{ flex: 1 }}>
									<Text
										alignSelf="flex-start"
										fontSize="xs"
										_dark={{
											color: "warmGray.50",
										}}
										color="coolGray.800"
									>
										{item.transaction_ref}
									</Text>
								</VStack>
							</HStack>
						) : (
							<HStack alignItems="flex-start" key={item[keyField]}>
								<VStack style={{ flex: 2 }}>
									<Text
										fontSize="xs"
										alignSelf="flex-start"
										key={item[keyField]}
									>
										{item.dbdate}
									</Text>
									<Text
										alignSelf="flex-start"
										fontSize="xs"
										style={{ fontSize: 8 }}
									>
										{item.transaction_ref}
									</Text>
								</VStack>
								<Spacer />
								<VStack style={{ flex: 1 }}>
									<Text
										alignSelf="flex-start"
										fontSize="xs"
										_dark={{
											color: "warmGray.50",
										}}
										color="coolGray.800"
									>
										{`R ${item.transaction_amount / 100}`}
									</Text>
									<Text
										alignSelf="flex-start"
										fontSize="xs"
										style={{ fontSize: 8 }}
									>
										{item.payment_method}
									</Text>
								</VStack>
								<Spacer />
							</HStack>
						)}
					</TouchableOpacity>
				)}
			</Box>
		);
	};

	function viewAttachment(claim) {
		setViewAttachment(claim);
	}

	return (
		<Box>
			{history === "Claims" ? (
				<Box
					bg="#fff"
					key={"productclaim"}
					borderBottomWidth="1"
					_dark={{
						borderColor: "gray.600",
					}}
					borderColor="coolGray.200"
					pl="4"
					pr="5"
					py="2"
					mb="5"
				>
					{data?.length > 0 ? (
						<View style={{ marginTop: 2 }}>
							<FlatList
								height={desktop ? null : height / 2}
								stickyHeaderIndices={[0]}
								ListHeaderComponent={() => (
									<HStack
										style={{
											flex: 1,
											justifyContent: "space-around",
											backgroundColor: "#fff",
										}}
									>
										{desktop ? (
											<Heading fontWeight="900" size="sm">
												IMEI/ Serial No
											</Heading>
										) : (
											<Heading fontWeight="900" size="sm">
												IMEI/SN/Status
											</Heading>
										)}
										<Spacer />
										<Heading fontWeight="900" size="sm">
											Date submitted
										</Heading>
										<Spacer />
										{desktop ? (
											<Heading fontWeight="900" size="sm">
												Status
											</Heading>
										) : null}
									</HStack>
								)}
								contentContainerStyle={{ flexGrow: 1 }}
								data={data}
								renderItem={renderItem}
								// ListFooterComponent={renderFooter}
								keyExtractor={(item) => item[keyField]}
							/>
							{renderFooter()}
						</View>
					) : (
						<Text>There are no records for {history}</Text>
					)}
				</Box>
			) : null}
			{history === "Transactions" ? (
				<Box
					bg="#fff"
					key={"productclaim"}
					borderBottomWidth="1"
					_dark={{
						borderColor: "gray.600",
					}}
					borderColor="coolGray.200"
					pl="4"
					pr="5"
					py="2"
					mb="5"
				>
					{data?.length > 0 ? (
						<View style={{ marginTop: 2 }}>
							<FlatList
								height={desktop ? null : height / 2}
								stickyHeaderIndices={[0]}
								ListHeaderComponent={() => (
									<HStack
										style={{
											flex: 1,
											justifyContent: "space-around",
											backgroundColor: "#fff",
										}}
									>
										{desktop ? <Text>DATE LOGGED</Text> : <Text>DATE/REF</Text>}
										{/* <Spacer /> */}
										{desktop ? <Text>ASSOC. IMEI[S]</Text> : null}
										{desktop ? (
											<Text>TRANSACTION AMOUNT</Text>
										) : (
											<Text>AMOUNT / TYPE</Text>
										)}
										{/* <Spacer /> */}
										{desktop ? <Text>REF</Text> : null}
									</HStack>
								)}
								contentContainerStyle={{ flexGrow: 1 }}
								data={data}
								renderItem={renderItem}
								// ListFooterComponent={renderFooter}
								keyExtractor={(item) => item[keyField]}
							/>
							{renderFooter()}
						</View>
					) : (
						<Text>There are no records for {history}</Text>
					)}
				</Box>
			) : null}
			<Modal
				isOpen={modalVisible}
				onClose={setModalVisible}
				size={desktop ? "xl" : "full"}
			>
				<Modal.Content maxH="800">
					<Modal.CloseButton />
					<Modal.Header>
						{history === "Claims" ? "Claim detail" : "Transaction detail"}
					</Modal.Header>
					{history === "Claims" && (
						<Modal.Body>
							<HStack space={5}>
								<VStack space={5}>
									<Text>Amount:</Text>
									<Text>Status:</Text>
									<Text>IMEI/SN:</Text>
									<Text>Date Submitted:</Text>
									<Text>Transaction Date:</Text>
									<Text>Balance Before:</Text>
								</VStack>
								<VStack space={5}>
									<Text>{claim.incentive_value}</Text>
									<Text>{claim?.system_status?.type_description}</Text>
									<Text>
										{claim?.product?.length > 0 ? (
											claim?.product.map((product) => {
												return (
													<Text key={product.guid}>{product.data_text}</Text>
												);
											})
										) : (
											<Text key={claim.productclaim_guid}>No Product</Text>
										)}
									</Text>
									<Text>{claim.submission_date}</Text>
									<Text>{claim.transaction_date}</Text>
									<Text>{claim.wallet_balance_before}</Text>
								</VStack>
							</HStack>
						</Modal.Body>
					)}
					{history === "Transactions" && (
						<Modal.Body>
							<HStack space={5}>
								<VStack space={5}>
									<Text>DATE LOGGED:</Text>
									<Text>TRANSACTION TYPE:</Text>
									<Text>ASSOC. IMEI[S]:</Text>
									<Text>TRANSACTION AMOUNT:</Text>
									<Text>BALANCE BEFORE:</Text>
									<Text>BALANCE AFTER:</Text>
								</VStack>
								<VStack space={5}>
									<Text>{transaction.dbdate}</Text>
									<Text>{transaction?.transacion_type}</Text>
									<Text>
										{transaction?.product_identifier !== undefined
											? transaction?.product_identifier
											: "N/A"}
									</Text>
									<Text>
										{currencyFormat(
											Math.abs(transaction.transaction_amount / 100)
										)}
									</Text>
									<Text>
										{currencyFormat(transaction.account_balance / 100)}
									</Text>
									<Text>
										{currencyFormat(
											(transaction.account_balance +
												transaction.transaction_amount) /
												100
										)}
									</Text>
								</VStack>
							</HStack>
						</Modal.Body>
					)}
					<Modal.Footer>
						<Button
							variant="ghost"
							colorScheme="blueGray"
							onPress={() => {
								setModalVisible(false);
							}}
						>
							Cancel
						</Button>
						{history === "Claims" && (
							<>
								<Button
									variant="outline"
									colorScheme="primary"
									onPress={() => {
										setModalVisible(false);
										viewAttachment(claim);
									}}
								>
									View Attachment
								</Button>
								{claim?.can_dispute !== false ? (
									<Button
										variant="outline"
										colorScheme="secondary"
										onPress={() => {
											setModalVisible(false);
											disputeClaim(claim);
										}}
									>
										Dispute Claim
									</Button>
								) : null}
							</>
						)}
					</Modal.Footer>
				</Modal.Content>
			</Modal>
		</Box>
	);
};
export const ComponentHeading = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	return <TextField {...props}>{props.children}</TextField>;
};
export const ComponentVStack = (props) => {
	const { hooks, desktop, sitepagecomponent_meta } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	let mobile = sitepagecomponent_meta?.mobile;
	var mobileProps = sitepagecomponent_meta;
	if (!desktop && mobile !== undefined) {
		mobileProps = { ...sitepagecomponent_meta, ...mobile };
	}
	return <VStack {...mobileProps}>{props.children}</VStack>;
};
export const ComponentHStack = (props) => {
	// console.log('ComponentHStack 560', props);
	const { hooks, desktop, sitepagecomponent_meta } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	let mobile = sitepagecomponent_meta?.mobile;
	var mobileProps = sitepagecomponent_meta;
	if (!desktop && mobile !== undefined) {
		mobileProps = { ...sitepagecomponent_meta, ...mobile };
	}
	if (!desktop && mobile?.forceVertical) {
		// console.log('Force forceVertical', mobile?.forceVertical);
		return <VStack {...mobileProps}>{props.children}</VStack>;
	}
	return <HStack {...mobileProps}>{props.children}</HStack>;
};
export const ComponentStack = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	return <Stack {...props}>{props.children}</Stack>;
};
export const ComponentCenter = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	return <Center {...props}>{props.children}</Center>;
};
export const ComponentText = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	return <TextField {...props}>{props.children}</TextField>;
};
export const ComponentCard = ({ children, props }) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
	} = hooks;
	return <Card {...props}>{children}</Card>;
};
export const ComponentMenu = (props) => {
	const { hooks, desktop } = props;
	const {
		component,
		routeName,
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
		getData,
		setTransaction,
		transaction,
	} = hooks;

	const Settings = useSelector((state) => state.setting.Settings);

	const getIsDisabled = () => {
		switch (props?.sitepagecomponent_meta?.component) {
			case "Withdrawal":
				return Settings?.ALLOW_EFT_WITHDRAWALS == 1
					? { isDisabled: false }
					: { isDisabled: true };
			case "CardLoad":
				return Settings?.ALLOW_CARD_LOADS == 1
					? { isDisabled: false }
					: { isDisabled: true };
			case "Statements":
				return Settings?.ALLOW_CARD_STATEMENT == 1
					? { isDisabled: false }
					: { isDisabled: true };

			default:
				return { isDisabled: props?.sitepagecomponent_meta?.isDisabled };
		}
	};

	return (
		<Button
			borderRadius="5"
			{...props.sitepagecomponent_meta}
			{...getIsDisabled()}
			{...(transaction === props.sitepagecomponent_meta?.component
				? { variant: "outline" }
				: {})}
			{...(history === props.sitepagecomponent_meta?.component
				? { variant: "outline" }
				: {})}
			onPress={() => {
				// console.log('My Transactions', props.sitepagecomponent_meta?.transactionType);
				routeName === "My Transactions"
					? setTransaction(
							props.sitepagecomponent_meta?.component,
							props.sitepagecomponent_meta?.transactionType
					  )
					: getData(1, props.sitepagecomponent_meta?.component);
				setHistory(props.sitepagecomponent_meta?.component);
			}}
		>
			{props.sitepagecomponent_meta?.name}
		</Button>
	);
};
export const ComponentMenuGroup = (props) => {
	const { hooks, desktop } = props;
	const {
		onSubmit,
		onCancel,
		setParams,
		history,
		setHistory,
		tableData,
		setTableData,
		onChange,
		params,
		component,
	} = hooks;
	return <Box>{props.children}</Box>;
};

export const dataFilter = (array, key, value) => {
	let result = array.filter((item) => {
		return item[key] === value;
	});
	if (result.length > 0) {
		return result[0];
	}
	return [];
};
export const currencyFormat = (num, currency = "R") => {
	return currency + num?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
